import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AdminDashboard from "./pages/AdminDashboard";
import ProAccessPage from "./pages/ProAccessPage";
import TermsPage from "./pages/TermsPage";
import DJListPage from "./pages/DJListPage";
import PublishingPage from "./pages/PublishingPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/pro" element={<ProAccessPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/dj-list" element={<DJListPage />} />
          <Route path="/publishing" element={<PublishingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
